export default "__VITE_PUBLIC_ASSET__d87a10f6__"